// 기본 정보 메타 (얇은 행) — 4타일 하위, 정체성 블록으로 병합.
//   계약상태 · 국가 · 언어 · 담당 매니저(🔒 퍼블릭 프로필 생성 시 제외).
//   PII(연락처·주소·메모)는 표시하지 않음. 값 없으면 "—".
import { orDash } from './format'

interface Props {
  contractType?: string
  country?: string
  language?: string
  manager?: string
}

function Cell({ label, value, last }: { label: string; value: string; last?: boolean }) {
  return (
    <div
      className={[
        'flex min-w-[180px] flex-1 flex-wrap items-center gap-x-2.5 gap-y-1 p-[12px_20px]',
        last ? '' : 'border-b border-line-hairline sm:border-b-0 sm:border-r',
      ].join(' ')}
    >
      <span className="font-text text-[11px] text-fg-3">{label}</span>
      <span className="break-keep font-text text-[14px] font-medium text-fg-1">{value}</span>
    </div>
  )
}

export function MetaStrip({ contractType, country, language, manager }: Props) {
  return (
    <div className="mt-5 flex flex-wrap border border-line-hairline bg-paper">
      <Cell label="계약상태" value={orDash(contractType)} />
      <Cell label="국가" value={orDash(country)} />
      <Cell label="언어" value={orDash(language)} />
      <Cell label="담당 매니저" value={orDash(manager)} last />
    </div>
  )
}
